module.exports = __webpack_public_path__ + "img/img-top.8f4fec5d.png";